import Vue from 'vue';
import VueRouter from 'vue-router';

import backupRoutes from './backup'
import companyRoutes from './company'
import searchRoutes from './search'
import userRoutes from './user'
import groupRoutes from './group'
import contactTypeRoutes from './contactType'

import labelRoutes from './label'
import categoryRoutes from './category'
import cityRoutes from './city'
import countryRoutes from './country'
import currencyRoutes from './currency'
import languageRoutes from './language'
import productRoutes from './product'
import postRoutes from './post'

import SignIn from '../components/SignIn';
import MainSlot from '../components/layout/MainSlot';
import store from '../store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn,
      meta: {
        requiresAuth: false,
        bodyClass: 'hold-transition login-page'
      }
    },
    {
      path: '/',
      component: MainSlot,
      children: [
        ...backupRoutes,
        ...labelRoutes,
        ...searchRoutes,
        ...companyRoutes,
        ...userRoutes,
        ...contactTypeRoutes,
        ...groupRoutes,
        ...categoryRoutes,
        ...cityRoutes,
        ...countryRoutes,
        ...currencyRoutes,
        ...languageRoutes,
        ...productRoutes,
        ...postRoutes,
      ],
      meta: {
        requiresAuth: true,
        bodyClass: 'hold-transition skin-blue sidebar-mini'
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let token = store.getters['auth/jwtDecoded'] || null
  let authorized = (token && token.exp > Date.now() / 1000)

  if (authorized) {
    if (to.matched.some(record => !record.meta.requiresAuth)) {
      next({name: 'CompanyList'})
    }
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      next({name: 'SignIn'})
    }
  }

  next()
})

export default router
